module.exports = __webpack_public_path__ + "static/media/nismarker.08dc3995.svg";